var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-list",style:({ 'margin-top': _vm.imgTop })},[_c('img',{staticClass:"no-list_icon",attrs:{"src":_vm.noImg,"alt":""}}),(_vm.noText)?_c('div',{staticClass:"no-list_text"},[_vm._v(_vm._s(_vm.noText))]):_vm._e(),(_vm.noDesc)?_c('div',{staticClass:"no-list_text_desc"},[_vm._v(_vm._s(_vm.noDesc))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }